import { api } from "./axios";

const contactApi = {
  getContacts: (params?: {
    page?: number;
    limit?: number;
    searchType?: "firstName" | "lastName" | "email" | "company";
    search?: string;
    sortBy?: "createdAt" | "firstName" | "lastName" | "email" | "company";
    sortOrder?: "ASC" | "DESC";
  }) => api.get("/contacts", { params }),

  createContact: (data: {
    firstName: string;
    lastName: string;
    company: string;
    role: string;
    email: string;
  }) => api.post("/contacts/create", data),

  updateContact: (id: number, data: Partial<{
    firstName: string;
    lastName: string;
    company: string;
    role: string;
    email: string;
  }>) => api.put(`/contacts/update/${id}`, data),

  deleteContact: (id: number) => api.delete(`/contacts/delete/${id}`),

  bulkContactUpload: (contacts: any[]) =>
    api.post("/contacts/bulk-create", { contacts }),
};



export default contactApi;
